import { FOLDERS3 } from '../../../config';

export default function setBucketURL(index) {
  const bucket = {
    dev: ['infograficos-estaticos-dev'],
    prod: ['https://deoliyp60f2gq.cloudfront.net'],
  };

  const host = window.location.host.split('.')[0];
  if (host === 'infograficos' || host === 'oglobo' || host === 'm' || host === 'blogs') {
    return `${bucket.prod[index]}/copa-passes/${FOLDERS3}`;
  }
  // return `https://${bucket.dev[index]}.s3.amazonaws.com/copa-passes/${FOLDERS3}`;
  return `${bucket.prod[index]}/copa-passes/${FOLDERS3}`;
}
